exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-status .form-uslev-newedit .control-group.one-child:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\n.m-b-60 {\r\n\tmargin-bottom: 60px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/app/user-management/division/division.component.css
// module id = ../../../../../src/app/user-management/division/division.component.css
// module chunks = main